




















import { Component, Vue } from 'vue-property-decorator';
import { shoppingModule } from '@/store';

@Component({
  name: 'service-navbar',
})
export default class ServiceNavbar extends Vue {
  get countMap() {
    return {
      SAND_BOX: shoppingModule.groupByStatus.SAND_BOX.length,
      BUYING: shoppingModule.groupByStatus.BUYING.length,
      FITTING: shoppingModule.groupByStatus.FITTING.length,
      BOUGHT: shoppingModule.groupByStatus.BOUGHT.length,
      REJECTED: shoppingModule.groupByStatus.REJECTED.length,
    };
  }
}
